import React from "react";

import Grid from "@material-ui/core/Grid";

import {
  Input,
  SelectField,
  withNamespace,
} from "components/Form/FormikControls";

import { BusinessLabelArchetypeLabels } from "constants/businessLabel";

const archetypeOptions = Object.entries(BusinessLabelArchetypeLabels).map(
  ([value, label]) => ({ value, label }),
);

interface BusinessLabelFormProps {
  namespace?: string;
}

export function BusinessLabelForm(props: BusinessLabelFormProps) {
  const { namespace: ns = "" } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Input
          name={withNamespace(ns, "name")}
          label="Name"
          required
          inputProps={{ maxLength: 50 }}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectField
          name={withNamespace(ns, "archetype")}
          label="Base"
          options={archetypeOptions}
          menuPortalTarget={document.body}
          isClearable
          tooltip="Optionally categorise this label by a base.  This may provide further functionality (e.g. Vendor, Buyer)."
        />
      </Grid>
    </Grid>
  );
}
